import { Platform } from 'react-native';
import { getLocales } from 'expo-localization';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { locale as momentLocale } from 'moment';
import 'moment/locale/nl';
import 'moment/locale/de';
import DE from 'assets/translations/de.json';
import NL from 'assets/translations/nl.json';
import { parse } from 'query-string';
import Constants from 'src/core/utils/Constants';
import { isAppLocale } from 'src/core/utils/Locales';

class TranslationService {
	private i18nInstance: typeof i18n;

	public constructor() {
		this.i18nInstance = this._setupI18n();
	}

	private _setupI18n(): typeof i18n {
		let defaultLanguage = getLocales()[0]?.languageTag.split('-')[0];

		if (Platform.OS === Constants.platformWeb) {
			const languageParam = parse(location.search)[Constants.paramsLanguage];
			if (languageParam && !Array.isArray(languageParam)) {
				defaultLanguage = languageParam;
			}
		}

		if (!defaultLanguage || !isAppLocale(defaultLanguage)) {
			defaultLanguage = Constants.localeNl;
		}

		i18n
			.use(initReactI18next)
			.init({
				resources: {
					[Constants.localeNl]: { translation: NL },
					[Constants.localeDe]: { translation: DE },
				},
				lng: defaultLanguage,
				fallbackLng: Constants.localeNl,
				compatibilityJSON: 'v4',
			})
			.catch(console.error);

		momentLocale(defaultLanguage);

		return i18n;
	}

	public async setLanguage(language: string): Promise<void> {
		const target = isAppLocale(language) ? language : Constants.localeNl;

		momentLocale(target);

		if (this.i18nInstance.language !== target) {
			await this.i18nInstance.changeLanguage(target);
		}
	}

	get i18n(): typeof i18n {
		return this.i18nInstance;
	}

	get language(): string {
		return this.i18nInstance.language;
	}
}

export default new TranslationService();
